var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__footer"},[_c('div',{staticClass:"__footer_btn"},[_c('div',{staticClass:"__btn __btn_dark_v2",class:{ __disabled: _vm.disabled !== false },on:{"click":_vm.showTips}},[_vm._v(" "+_vm._s(_vm.str)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }